const FeatureIcon = ({
  children,
  style,
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) => {
  return <span style={style}>{children}</span>
}

export default FeatureIcon
